@if (title) {
    <h4 class="articles-block__heading">{{ title }}</h4>
}
<section
    class="articles-block__container"
    [style.gridTemplateColumns]="'repeat(' + articles?.length + ', 1fr)'"
    [class]="'articles-block__container--' + articles?.length"
>
    @for (article of articles; track article) {
        <nw-article-card
            [image]="article.image"
            [category]="article.category"
            [author]="article.author"
            [avatar]="article.avatar"
            [date]="article.date"
            [horizontal]="false"
            [path]="article.path"
            [categorycolor]="article.categorycolor"
            [type]="article.type"
            [imageTint]="article.imageTint"
        >
            {{ article.title }}</nw-article-card
        >
    }
</section>
